import { Box, Input, useColorModeValue } from '@chakra-ui/react';

interface FormulaEditor {}
const FormulaEditor = () => {
  const borderColor = useColorModeValue('gray.200', 'gray.800');

  return (
    <Box
      width="calc(100% - 40px)"
      p="0px 6px"
      rounded="md"
      height="100%"
      border="1px"
      borderColor={borderColor}
      background="InfoBackground"
    >
      <Input variant="unstyled" width="100%" />
    </Box>
  );
};

export default FormulaEditor;
